import React from 'react';
import {Switch ,FormControl,FormGroup,FormControlLabel,Typography} from '@material-ui/core'
import {isEmpty, isUndefined} from 'lodash'
import { injectIntl } from 'react-intl';

function CheckBoxInputAnteckningar(props) {
    const ChangeMstate=(e)=>{
        console.log(e.target.checked)
        props.onChangeMstate(e.target.checked,[
            {Meta:"Anteckningar",MetaN:`${props.MetaN.split("_")[0]}_Anteckningar`,Value:0,Checked:e.target.checked,Type:"Column",isSwitch:true},
            {Meta:"Senaste",MetaN:`${props.MetaN.split("_")[0]}_Anteckningar_skapaDatum`,Value:0,Checked:e.target.checked,Type:"Column",isSwitch:false}
        ],3)
    }
    //Anteckningar
    const GetLabel=()=>{
        switch(props.Meta){
            case "Anteckningar": return props.intl.formatMessage({ id: 'Annotations' });
            default: return props.Meta
        }
    }
    return (
        <>
           <FormControl component="fieldset" fullWidth style={{margin:"3px auto"}}>
                <FormGroup aria-label="position" row>
                <FormControlLabel
                value={true}                
                control={
                    <Switch color="primary" 
                    disabled={props.disabled} 
                    checked={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?false:true}
                    onChange={ChangeMstate}
                    size="small"
                    />
                }
                label={ <Typography variant="subtitle1" style={{fontSize:14}}>{GetLabel()}</Typography>}
                labelPlacement={"end"}
                />
                </FormGroup>
             </FormControl> 
        </>
    );
}

export default injectIntl(CheckBoxInputAnteckningar);